import { render, staticRenderFns } from "./StarRat.vue?vue&type=template&id=b3272650&scoped=true"
import script from "./StarRat.vue?vue&type=script&lang=js"
export * from "./StarRat.vue?vue&type=script&lang=js"
import style0 from "./StarRat.vue?vue&type=style&index=0&id=b3272650&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3272650",
  null
  
)

export default component.exports